/**
 * This file is kept for backward compatibility.
 * The hook is now in @punchup/venues package.
 */
export { useAutoJoinWaitlist } from "@punchup/venues/client";
